const TableDataCell = ({ children, isToday = false, isSubstituteProfessor = false, isCancelClass = false, title }) => {
    return  (
        <td 
            className={`
                main-list__table-cell 
                ${isToday ? 'main-list__table-cell--current' : ''} 
                ${isSubstituteProfessor ? 'main-list__table-cell--substitute' : ''}
                ${isCancelClass ? 'main-list__table-cell--cancel' : ''}
            `}
            title={title}
        >
            {children}
        </td>
    );
};

export default TableDataCell;
